import React from 'react'
import PropTypes from 'prop-types'

const ColorSwatch = ({height, width}) => {
    return (
        <svg
            width={height}
            height={width}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#paint0_angular_103820_12995_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(0.0160016 0.00750156 -0.00819338 0.0174773 12.5004 12.0053)">
                    <foreignObject x="-797.677" y="-797.677" width="1595.35" height="1595.35">
                        <div
                            xmlns="http://www.w3.org/1999/xhtml"
                            style={{
                                background:
                                    'conic-gradient(from 90deg,rgba(196, 0, 0, 1) 0deg,rgba(207, 145, 0, 1) 42.3672deg,rgba(194, 198, 0, 1) 89.0472deg,rgba(0, 203, 20, 1) 139.213deg,rgba(0, 203, 239, 1) 190.542deg,rgba(26, 0, 224, 1) 234.911deg,rgba(196, 0, 173, 1) 311.412deg,rgba(196, 0, 0, 1) 360deg)',
                                height: '100%',
                                width: '100%',
                                opacity: 1
                            }}
                        ></div>
                    </foreignObject>
                </g>
            </g>
            <rect
                x="2.90039"
                y="2.40527"
                width="19.2"
                height="19.2"
                rx="9.6"
                data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.76881510019302368,"g":0.0,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.81471353769302368,"g":0.57029950618743896,"b":0.0,"a":1.0},"position":0.11768653243780136},{"color":{"r":0.76406782865524292,"g":0.77701824903488159,"b":0.0,"a":1.0},"position":0.24735321104526520},{"color":{"r":0.0,"g":0.79817706346511841,"b":0.079817637801170349,"a":1.0},"position":0.38670265674591064},{"color":{"r":0.0,"g":0.79955899715423584,"b":0.94065755605697632,"a":1.0},"position":0.52928322553634644},{"color":{"r":0.10293402522802353,"g":0.0,"b":0.88229167461395264,"a":1.0},"position":0.65253102779388428},{"color":{"r":0.76992189884185791,"g":0.0,"b":0.68009763956069946,"a":1.0},"position":0.86503434181213379},{"color":{"r":0.76862746477127075,"g":0.0,"b":0.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.76881510019302368,"g":0.0,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.81471353769302368,"g":0.57029950618743896,"b":0.0,"a":1.0},"position":0.11768653243780136},{"color":{"r":0.76406782865524292,"g":0.77701824903488159,"b":0.0,"a":1.0},"position":0.24735321104526520},{"color":{"r":0.0,"g":0.79817706346511841,"b":0.079817637801170349,"a":1.0},"position":0.38670265674591064},{"color":{"r":0.0,"g":0.79955899715423584,"b":0.94065755605697632,"a":1.0},"position":0.52928322553634644},{"color":{"r":0.10293402522802353,"g":0.0,"b":0.88229167461395264,"a":1.0},"position":0.65253102779388428},{"color":{"r":0.76992189884185791,"g":0.0,"b":0.68009763956069946,"a":1.0},"position":0.86503434181213379},{"color":{"r":0.76862746477127075,"g":0.0,"b":0.0,"a":1.0},"position":1.0}],"transform":{"m00":32.003124237060547,"m01":-16.386753082275391,"m02":4.6922068595886230,"m10":15.003123283386230,"m11":34.954536437988281,"m12":-12.973557472229004},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
            />
            <path
                d="M1 12.0049C1 5.65361 6.14873 0.504883 12.5 0.504883C18.8513 0.504883 24 5.65361 24 12.0049C24 18.3562 18.8513 23.5049 12.5 23.5049C6.14873 23.5049 1 18.3562 1 12.0049Z"
                stroke="black"
            />
            <defs>
                <clipPath id="paint0_angular_103820_12995_clip_path">
                    <rect x="2.90039" y="2.40527" width="19.2" height="19.2" rx="9.6" />
                </clipPath>
            </defs>
        </svg>
    )
}

ColorSwatch.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number
}

export default ColorSwatch
